<template>
  <v-container>
    <v-layout row wrap justify-center class="mt-3">
      <v-flex xs12 class="text-xs-center">
        <h1>Enrollments</h1>
      </v-flex>
      <v-flex xs12 sm10 md8>
        <v-card class="info" v-for="(item, index) in enrollments" v-bind:key="`item-${index}`">
          <v-list>
              <v-list-tile icon>
                <v-list-tile-avatar>
                  <v-icon left>enrollment_on</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.enrollmentName"></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <template v-if="userIsCreator(index)">
                    <app-edit-enrollment-dialog :enrollment="enrollment(index)"></app-edit-enrollment-dialog>
                  </template>                  
                </v-list-tile-action>
                <v-list-tile-action>
                  <v-btn icon @click="onDeleteEnrollment(item)">
                    <v-icon class="grey--text text--lighten-1">delete</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <v-list-tile-action>
                  <v-btn icon ripple :to="'/enrollments/' + item.enrollmentId">
                    <v-icon v-bind:color="item.active ? 'primary' : 'grey'">navigate_next</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
          </v-list>          
        </v-card>      
      </v-flex>
    </v-layout>	
  </v-container>
</template>

<script>
export default {
  props: ['id'],
  data () {
    return {
    }
  },
  computed: {
    enrollments () {
      return this.$store.getters.loadedEnrollments
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    enrollment (index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedEnrollment(this.enrollments[index].enrollmentId))
      return this.$store.getters.loadedEnrollment(this.enrollments[index].enrollmentId)
    },
    userIsCreator (index) {
      console.dir('THIS: ' + this.enrollments[index].creatorId)
      var holder = this.enrollments[index].creatorId
      var holder2 = this.$store.getters.user.id
      if (!this.userIsAuthenticated) {
        return false
      }
      return holder2 === holder
    },
    onDeleteEnrollment (enrollment) {
      console.log('Delete this: ' + JSON.stringify(enrollment))
      this.$store.dispatch('deleteEnrollmentData', enrollment)
      this.$router.push('/enrollments')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Enrollments.vue?6e50ec14